<script>
import SLSClienteService from '@/services/Cadastros/Cliente/SLSCliente.service';
import SLSTabelaPrecoService from '@/services/SistemaDKP/SLSTabelapreco.service';
import { mapGetters } from 'vuex';
import { BOverlay } from 'bootstrap-vue';
import SLSCondicaoPagamentoService from '@/services/SistemaDKP/SLSCondicaoPagamento.service';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
import SLSPicService from '@/services/Operacoes/SLSPic.service';
import _ from 'lodash';

const slsClienteService = new SLSClienteService();
const slsCondicaoPagamentoService = new SLSCondicaoPagamentoService();
const slsTabelapreco = new SLSTabelaPrecoService();
const picService = new SLSPicService();

export default {
  name: 'Index',
  components: { BOverlay },
  filters: {
    removerZerosEsquerda(value) {
      if (!value) return '';
      return String(value).replace(/^0+/, '');
    },
  },
  data() {
    return {
      isLoading: false,
      isRepresentante: false,
      isClienteFinal: false,
      isOtherProfile: false,
      loadingTimeout: null,
      filtersHeader: {
        representanteid: '',
        clienteiderp: '',
        clienterazaosocial: '',
        clienteDocumento: '',
        clienteCidade: '',
      },
      dataAlreadyFetched: {},
      debounceTimer: null,
      currentPage: 1,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      fields: [
        { key: 'clienteiderp', label: 'Código' },
        { key: 'clienteDocumento', label: 'Documento' },
        { key: 'clienterazaosocial', label: 'Razão Social' },
        { key: 'cidade', label: 'Cidade' },
        { key: 'clientestatus', label: 'Situação' },
        { key: 'acoes', label: 'Ações' },
      ],
    };
  },
  watch: {
    currentPage: {
      handler(value) {
        this.$store.commit('SLSCliente/SET_FILTERS', {
          ...this.$store.getters['SLSCliente/filters'],
          page: value,
        });
      },
    },
  },
  computed: {
    ...mapGetters('SLSCliente', {
      filters: 'filters',
      getClientes: 'clientes',
    }),
    ...mapGetters('InfoPedido', {
      formInfoPedido: 'GET_FORM_INFO_PEDIDO',
    }),
    dataMetaRepresentante() {
      const localCount = this.getClientes ? this.getClientes.length : 0;
      const total = this.filters ? this.filters.total : 0;
      const page = this.filters ? this.filters.page : 1;
      const perPage = this.filters ? this.filters.perPage : 10;

      if (total === 0) {
        return 'Não há registros para exibir';
      }

      const inicio = (perPage * (page - 1)) + 1;
      const fim = Math.min(inicio + localCount - 1, total);

      return `Mostrando ${inicio} de ${fim} entradas de ${total} entradas`;
    },
  },
  methods: {
    setLoading(status) {
      this.isLoading = status;
      this.$store.commit('SLSCliente/SET_LOADING', status);

      if (!status && this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }
    },
    verificarPerfilUsuario() {
      try {
        const perfilLogado = JSON.parse(localStorage.getItem('perfilLogado'));
        this.isRepresentante = perfilLogado && perfilLogado.perfil_acesso_nome === 'Representante';
        this.isClienteFinal = perfilLogado && perfilLogado.perfil_acesso_nome === 'ClienteFinal';
        this.isOtherProfile = perfilLogado
          && perfilLogado.perfil_acesso_nome !== 'Representante'
          && perfilLogado.perfil_acesso_nome !== 'ClienteFinal';
      } catch (error) {
        console.error('Erro ao verificar perfil do usuário:', error);
        this.isRepresentante = false;
        this.isClienteFinal = false;
        this.isOtherProfile = false;
      }
    },
    async info(item) {
      try {
        if (typeof this.setLoading === 'function') {
          this.setLoading(true);
        } else {
          this.isLoading = true;
        }

        if (this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'].cliente.clienteiderp === item.clienteiderp) {
          this.$bvModal.hide('modal-buscar-cliente-info-pedido');
          return;
        }

        this.$store.commit('InfoPedido/SET_CLIENTE_FORM', item);
        this.$store.commit('InfoPedido/SET_LOADING_CLIENTE', true);
        this.$store.commit('InfoPedido/SET_IS_LOADING', true);

        let data;
        if (this.isRepresentante || this.isOtherProfile) {
          data = await slsClienteService.getInfoPedidoNovo(item.clienteiderp);
        } else {
          data = await slsClienteService.getInfoPedidoByClienteId(item.clienteiderp);
        }

        this.$root.$emit('cliente:selected-from-modal', data);

        console.log('Dados do cliente recebidos:', data);

        const hasCondPagto = data.optionsCondPagtoCliente && data.optionsCondPagtoCliente.length > 0;
        if (!hasCondPagto) {
          console.log('Cliente não possui condições de pagamento - limpando campos');

          if (data.condicaoPagamento) {
            data.condicaoPagamento = {
              condicaopagamentoid: '',
              condicaopagamentodescricao: '',
            };
          }

          this.$store.commit('InfoPedido/SET_CONDICAO_PAGAMENTO_FORM', {
            condicaopagamentoid: '',
            condicaopagamentodescricao: '',
          });

          this.$store.commit('intensPedido/SET_CAPA_PEDIDO', {
            ...this.$store.getters['intensPedido/getFormData'].dataCapaPedido,
            condicaopagamentoid: '',
            condicaopagamentodescricao: '',
          });

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Aviso',
              text: 'Não foram encontradas condições de pagamento para este cliente',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
        }

        const hasTabelaPreco = data.optionsTabelaPrecoCliente && data.optionsTabelaPrecoCliente.length > 0;
        if (!hasTabelaPreco) {
          console.log('Cliente não possui tabelas de preço - limpando campos');

          if (data.tabelaPreco) {
            data.tabelaPreco = {
              tabelapreco_id: '',
              tabelapreco_descricao: '',
            };
          }

          this.$store.commit('InfoPedido/SET_TABELA_PRECO', {
            tabelapreco_id: '',
            tabelapreco_descricao: '',
          });

          this.$store.commit('intensPedido/SET_CAPA_PEDIDO', {
            ...this.$store.getters['intensPedido/getFormData'].dataCapaPedido,
            tabelaprecoid: '',
            tabelapreco_descricao: '',
          });

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Aviso',
              text: 'Não foram encontradas tabelas de preço para este cliente',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
        }

        if (data.cliente && data.cliente.tabelaprecoid && data.optionsTabelaPrecoCliente && data.optionsTabelaPrecoCliente.length > 0) {
          const tabelaPrecoPrincipal = data.optionsTabelaPrecoCliente.find(
            (tabela) => tabela.tabelapreco_id === data.cliente.tabelaprecoid,
          );

          if (tabelaPrecoPrincipal) {
            console.log('Tabela de preço principal encontrada nas opções:', tabelaPrecoPrincipal);
            data.tabelaPreco = {
              tabelapreco_id: tabelaPrecoPrincipal.tabelapreco_id,
              tabelapreco_descricao: tabelaPrecoPrincipal.tabelapreco_descricao,
            };
          } else {
            console.log('Tabela de preço principal não está disponível nas opções');
          }
        }

        this.$store.commit('InfoPedido/SET_OPTIONS_TABELA_PRECO', data.optionsTabelaPrecoCliente || []);
        this.$store.commit('InfoPedido/SET_OPTIONS_COND_PAGAMENTO', data.optionsCondPagtoCliente || []);
        this.$store.commit('intensPedido/SET_IFO_CLIENTE', data);

        try {
          const [condPagamentos, tabelasPreco] = await Promise.all([
            slsCondicaoPagamentoService.GetCondPagtoByClienteId(data.cliente.clienteid),
            slsTabelapreco.getTabelaPrecoByClienteIdERP(data.cliente.clienteiderp),
          ]);

          this.$store.commit('SLSCondicaoPagamento/SET_CURRENT_COND_PAGTO', condPagamentos || []);
          this.$store.commit('SLSTabelapreco/SET_TABELAPRECOS', tabelasPreco || []);

          if (!hasCondPagto || !Array.isArray(condPagamentos) || condPagamentos.length === 0) {
            console.log('Verificação adicional confirma: Cliente não possui condições de pagamento');

            this.$store.commit('InfoPedido/SET_CONDICAO_PAGAMENTO_FORM', {
              condicaopagamentoid: '',
              condicaopagamentodescricao: '',
            });

            if (data.condicaoPagamento) {
              data.condicaoPagamento = {
                condicaopagamentoid: '',
                condicaopagamentodescricao: '',
              };
            }
          }

          if (!hasTabelaPreco || !Array.isArray(tabelasPreco) || tabelasPreco.length === 0) {
            console.log('Verificação adicional confirma: Cliente não possui tabelas de preço');

            this.$store.commit('InfoPedido/SET_TABELA_PRECO', {
              tabelapreco_id: '',
              tabelapreco_descricao: '',
            });

            if (data.tabelaPreco) {
              data.tabelaPreco = {
                tabelapreco_id: '',
                tabelapreco_descricao: '',
              };
            }
          }
        } catch (error) {
          console.error('Erro na verificação adicional de condições e tabelas:', error);
        }

        this.$store.commit('InfoPedido/SET_CLIENTE_DATA', {
          clienteData: data,
          enderecoEntrega: data.enderecoEntrega,
          dataCapaPedido: {
            estabelecimentoid: data.estabelecimento?.estabelecimentoid,
            clientenomeabreviado: data.cliente?.clientenomeabreviado,
            naturezaoperacaoid: data.cliente?.naturezaoperacaoid,
            canal_venda_id: data.cliente?.canal_venda_id,
            clienteisentoie: data.cliente?.clienteisentoie,
            tabelaprecoid: data.tabelaPreco?.tabelapreco_id || '',
            condicaopagamentoid: data.condicaoPagamento?.condicaopagamentoid || '',
          },
        });

        this.$store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', {
          ...data,
          representante: this.formInfoPedido.representante,
        });

        const filtrosPic = {};
        if (data.cliente?.clienteid) filtrosPic.clienteid = data.cliente.clienteid;
        if (data.estabelecimento?.estabelecimentoid) filtrosPic.estabelecimentoid = data.estabelecimento.estabelecimentoid;

        if (hasTabelaPreco && data.tabelaPreco?.tabelapreco_id) {
          filtrosPic.tabelaprecoId = data.tabelaPreco.tabelapreco_id;
        }

        if (hasCondPagto && data.condicaoPagamento?.condicaopagamentoid) {
          filtrosPic.condicaopagamentoid = data.condicaoPagamento.condicaopagamentoid;
        }

        if (Object.keys(filtrosPic).length > 0) {
          this.$store.commit('PicStore/SET_FILTERS', filtrosPic);
        }

        if (data.cliente?.clienteid && data.estabelecimento?.estabelecimentoid
          && (hasTabelaPreco || hasCondPagto)) {
          try {
            await picService.getPicPedidos();
          } catch (picError) {
            console.error('Erro ao buscar PICs:', picError);
          }
        }

        // Salvamento no localStorage
        // if (this.$store.getters['auth/IS_LOGGED_IN']) {
        //   const updatedFormData = this.$store.getters["InfoPedido/GET_FORM_INFO_PEDIDO"];
        //   try {
        //     const userData = JSON.parse(localStorage.getItem('userData'));
        //     const userId = userData?.id || 'default';
        //     localStorage.setItem(`infoPedidoForm_${userId}`, JSON.stringify(updatedFormData));
        //   } catch (error) {
        //     console.error('Erro ao salvar dados do cliente:', error);
        //   }
        // }

        this.$bvModal.hide('modal-buscar-cliente-info-pedido');
      } catch (error) {
        console.error('Erro ao processar seleção de cliente:', error);
        this.$bvModal.hide('modal-buscar-cliente-info-pedido');
      } finally {
        this.$store.commit('InfoPedido/SET_LOADING_CLIENTE', false);
        this.$store.commit('InfoPedido/SET_IS_LOADING', false);

        if (typeof this.setLoading === 'function') {
          this.setLoading(false);
        } else {
          this.isLoading = false;
        }
      }
    },
    resetInfoModal() {
      this.infoModal.title = '';
      this.infoModal.content = '';
    },
    async handlePageChange(value) {
      try {
        this.setLoading(true);

        const representanteId = this.$store.getters['SLSCliente/filters'].representanteid
          || this.formInfoPedido.representante?.representanteid;

        const filtros = {
          ...this.$store.getters['SLSCliente/filters'],
          page: value,
        };

        if (!representanteId) {
          console.warn('Não é possível buscar clientes sem representante selecionado');
          return;
        }

        filtros.representanteid = representanteId;
        this.$store.commit('SLSCliente/SET_FILTERS', filtros);

        if (this.isRepresentante || this.isOtherProfile) {
          console.log('Usando listarClientePorRepresentante no handlePageChange');
          await slsClienteService.listarClientePorRepresentante(representanteId, filtros);
        } else {
          await slsClienteService.listarClienteInfoPedido(filtros);
        }
      } catch (error) {
        console.error('Erro ao mudar página:', error);
      } finally {
        this.setLoading(false);
      }
    },
    async initializeFilters() {
      try {
        this.setLoading(true);

        const representanteId = this.formInfoPedido.representante?.representanteid;
        const isCreatePedidos = this.$router.currentRoute.name === 'pedidos-vendas-create';

        if (!representanteId) {
          console.warn('Não é possível inicializar filtros sem representante selecionado');
          return;
        }

        if (representanteId) {
          if (isCreatePedidos) {
            this.filtersHeader = {
              representanteid: representanteId,
              clienteiderp: '',
              clienterazaosocial: '',
              clienteDocumento: '',
              clienteCidade: '',
            };

            this.$store.commit('SLSCliente/SET_FILTERS', {
              page: 1,
              perPage: 10,
              representanteid: representanteId,
            });

            this.currentPage = 1;

            if (this.isRepresentante || this.isOtherProfile) {
              console.log('Usando listarClientePorRepresentante no initializeFilters');
              await slsClienteService.listarClientePorRepresentante(representanteId, {
                page: 1,
                perPage: 10,
              });
            } else {
              await slsClienteService.listarClienteInfoPedido({
                representanteid: representanteId,
                page: 1,
              });
            }

            return;
          }

          const clientes = this.getClientes;
          const storedFilters = this.filters;

          // if (clientes && clientes.length > 0 &&
          //   this.dataAlreadyFetched[representanteId] &&
          //   storedFilters.representanteid === representanteId) {

          //   this.filtersHeader = {
          //     representanteid: representanteId,
          //     clienteid: storedFilters.clienteid || '',
          //     clienterazaosocial: storedFilters.clienterazaosocial || '',
          //     clienteDocumento: storedFilters.clienteDocumento || '',
          //     clienteCidade: storedFilters.clienteCidade || '',
          //   };

          //   this.currentPage = storedFilters.page || 1;
          //   return;
          // }

          this.filtersHeader = {
            representanteid: representanteId,
            clienteiderp: '',
            clienterazaosocial: '',
            clienteDocumento: '',
            clienteCidade: '',
          };

          this.$store.commit('SLSCliente/SET_FILTERS_CLIENTE_ID', null);
          this.$store.commit('SLSCliente/SET_FILTERS_RAZAO_SOCIAL', null);
          this.$store.commit('SLSCliente/SET_FILTERS_CLIENTE_DOCUMENTO', null);
          this.$store.commit('SLSCliente/SET_FILTERS_CLIENTE_CIDADE', null);

          this.$store.commit('SLSCliente/SET_FILTERS', {
            page: 1,
            perPage: 10,
            representanteid: representanteId,
          });

          this.currentPage = 1;

          if (this.isRepresentante || this.isOtherProfile) {
            console.log('Usando listarClientePorRepresentante no initializeFilters (caso alternativo)');
            await slsClienteService.listarClientePorRepresentante(representanteId, {
              page: 1,
              perPage: 10,
            });
          } else {
            await slsClienteService.listarClienteInfoPedido({
              representanteid: representanteId,
              page: 1,
            });
          }

          // this.dataAlreadyFetched[representanteId] = true;
        }
      } catch (error) {
        console.error('Erro ao inicializar filtros:', error);
      } finally {
        this.setLoading(false);
      }
    },
    async handleFiltersHeader(filteredItems) {
      this.debouncedFilters();
    },
    // Filtros com debounce
    debouncedFilters: _.debounce(async function () {
      this.setLoading(true);

      try {
        const representanteId = this.filtersHeader.representanteid
          || this.formInfoPedido.representante?.representanteid
          || this.$store.getters['InfoPedido/GET_REPRESENTANTE_ID'];

        const filtrosAtualizados = {
          ...this.$store.getters['SLSCliente/filters'],
          ...this.filtersHeader,
        };

        if (!representanteId) {
          console.warn('Não é possível filtrar clientes sem representante selecionado');
          return;
        }

        filtrosAtualizados.representanteid = representanteId;
        this.$store.commit('SLSCliente/SET_FILTERS', filtrosAtualizados);

        if (this.filtersHeader.clienteiderp) {
          this.$store.commit('SLSCliente/SET_FILTERS_CLIENTE_ID', this.filtersHeader.clienteiderp);
        }

        if (this.filtersHeader.clienterazaosocial) {
          this.$store.commit('SLSCliente/SET_FILTERS_RAZAO_SOCIAL', this.filtersHeader.clienterazaosocial);
        }

        if (this.filtersHeader.clienteDocumento) {
          this.$store.commit('SLSCliente/SET_FILTERS_CLIENTE_DOCUMENTO', this.filtersHeader.clienteDocumento);
        }

        if (this.filtersHeader.clienteCidade) {
          this.$store.commit('SLSCliente/SET_FILTERS_CLIENTE_CIDADE', this.filtersHeader.clienteCidade);
        }

        if (this.isRepresentante || this.isOtherProfile) {
          await slsClienteService.listarClientePorRepresentante(representanteId, filtrosAtualizados);
        } else {
          await slsClienteService.listarClienteInfoPedido(filtrosAtualizados);
        }
      } catch (error) {
        console.error('Erro ao filtrar clientes:', error);
      } finally {
        this.setLoading(false);
      }
    }, 500),
    async resertFilters() {
      const representanteId = this.formInfoPedido.representante?.representanteid
        || this.$store.getters['InfoPedido/GET_REPRESENTANTE_ID'];

      this.filtersHeader = {
        representanteid: representanteId || '',
        clienteiderp: '',
        clienterazaosocial: '',
        clienteDocumento: '',
        clienteCidade: '',
      };

      this.currentPage = 1;

      this.$store.commit('SLSCliente/SET_FILTERS_CLIENTE_ID', null);
      this.$store.commit('SLSCliente/SET_FILTERS_RAZAO_SOCIAL', null);
      this.$store.commit('SLSCliente/SET_FILTERS_CLIENTE_DOCUMENTO', null);
      this.$store.commit('SLSCliente/SET_FILTERS_CLIENTE_CIDADE', null);

      if (representanteId && !this.isOtherProfile) {
        this.$store.commit('SLSCliente/SET_FILTERS', {
          page: 1,
          perPage: 10,
          sortBy: null,
          sortDesc: null,
          clienteid: null,
          clienterazaosocial: null,
          clienteDocumento: null,
          clienteCidade: null,
          representanteid: representanteId,
        });
      } else if (this.isOtherProfile) {
        this.$store.commit('SLSCliente/SET_FILTERS', {
          page: 1,
          perPage: 10,
          sortBy: null,
          sortDesc: null,
          clienteid: null,
          clienterazaosocial: null,
          clienteDocumento: null,
          clienteCidade: null,
        });
      }

      if (this.isRepresentante || this.isOtherProfile) {
        await slsClienteService.listarClientePorRepresentante(representanteId);
      } else {
        await slsClienteService.listarClienteInfoPedido({ representanteid: representanteId });
      }
    },
    async handleModalShow() {
      this.verificarPerfilUsuario();
      await this.resertFilters();
    },
  },
  created() {
    this.verificarPerfilUsuario();
  },
  mounted() {
    this.verificarPerfilUsuario();

    this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
      if (modalId === 'modal-buscar-cliente-info-pedido') {
        this.isLoading = false;
        this.$store.commit('SLSCliente/SET_LOADING', false);
      }
    });
  },

  beforeDestroy() {
    this.$root.$off('bv::modal::hidden');
  },
};
</script>

<template>
  <b-modal id="modal-buscar-cliente-info-pedido" size="xl" ref="modalBuscarRepresentante" title="Pesquisar Cliente"
    ok-only @show="handleModalShow" ok-title="FECHAR">
    <b-overlay variant="white" :show="$store.getters['SLSCliente/loading'] || isLoading" spinner-variant="primary"
      blur="0" opacity=".75" rounded="sm">
      <b-row>
        <b-col cols="12" md="2">
          <b-form-group label="Cod Cliente:" label-for="codCliente">
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>
              <b-form-input id="codCliente" placeholder="Código" v-model="filtersHeader.clienteiderp" />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="2">
          <b-form-group label="Razão Social:" label-for="disabledInput">
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>
              <b-form-input placeholder="Nome" v-model="filtersHeader.clienterazaosocial" />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="2">
          <b-form-group label="CNPJ:" label-for="disabledInput">
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>
              <b-form-input placeholder="Nome" v-model="filtersHeader.clienteDocumento" />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-group label="Cidade Cliente:" label-for="disabledInput">
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>
              <b-form-input placeholder="Nome" v-model="filtersHeader.clienteCidade" />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="2" align-self="center">
          <b-row>
            <b-col cols="12" md="6">
              <b-button variant="success" @click="handleFiltersHeader">
                Filtrar
              </b-button>
            </b-col>
            <b-col cols="12" md="6">
              <b-button variant="danger" @click="resertFilters">
                Limpar
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row no-gutters>
        <b-col cols="12">
          <b-table striped hover responsive :current-page="currentPage" :items="$store.getters['SLSCliente/clientes']"
            :fields="fields" show-empty empty-text="Nenhum cliente encontrado">
            <template #cell(clienteiderp)="data">
              {{ data.value | removerZerosEsquerda }}
            </template>
            <template #cell(acoes)="data">
              <b-button size="sm" variant="primary" @click="info(data.item, data.index, $event.target)">
                Selecionar
              </b-button>
            </template>

            <template #cell(clienteDocumento)="data">
              {{ data.value | formatarDocumento }}
            </template>

            <template #cell(representanteativo)="data">
              <b-badge :variant="data.value === 1 ? 'success' : 'danger'">
                {{ data.value === 1 ? 'Ativo' : 'Inativo' }}
              </b-badge>
            </template>
          </b-table>
        </b-col>

        <b-col cols="12">
          <div class="mx-2 mb-2">
            <b-row>
              <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
                <span class="text-muted">{{ dataMetaRepresentante }}</span>
              </b-col>
              <!-- Pagination -->
              <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
                <b-pagination v-model="currentPage" :total-rows="filters.total" :per-page="filters.perPage"
                  @change="handlePageChange($event)" first-number last-number align="center" class="my-0" />
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-overlay>
  </b-modal>
</template>

<style scoped lang="scss"></style>
